import React, { useEffect, useState ,useRef, useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';


import './styles.css';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import TituloPagina from '../Includes/Titulos';
import api from '../../services/api';


export default function DadosPagamento() {
    const { t } = useTranslation();
    const history = useHistory();
    const BASE_URL = 'https://agrobrazilapp.com/';
    const USER_EMAIL = sessionStorage.getItem('email');
    const USER_TOKEN = sessionStorage.getItem('token');
    const paymentForm = JSON.parse(sessionStorage.getItem('paymentForm'));
    const selectedPlan = JSON.parse(sessionStorage.getItem('selectedPlan'));
    const [routeChange, setRouteChange] = useState();
    const stateInputRef = useRef(null);
    const cityInputRef = useRef(null);
    const zip_CodeInputRef= useRef(null);
    const numInputRef = useRef(null);

   
   
    
    
    class DataForm extends React.Component {
    
        render() {

          return (
            <form id="payment-data"  onSubmit={handleSubmit} >
                  
                <p class="text-config">{t('pages.paymentData.paymentBy') + paymentForm}</p>
                <input id="state" ref={stateInputRef}name='state' type="text"  placeholder={t('pages.paymentData.placeholder.state')} class="inputDados" required></input><br />
                <input id="city"ref={cityInputRef} type="text" placeholder={t('pages.paymentData.placeholder.city')} class="inputDados" required></input><br />
                <input id="cep"ref={zip_CodeInputRef} name='cep' type="text" placeholder={t('pages.paymentData.placeholder.CEP')} class="inputDados" required></input><br />
                <input id="ruaAv" type="text" placeholder={t('pages.paymentData.placeholder.street')} class="inputDados" required></input><br />
                <input id="num"ref={ numInputRef} type="text" placeholder={t('pages.paymentData.placeholder.number')} class="inputDados" required></input><br />
                <input id="complemento" type="text" placeholder={t('pages.paymentData.placeholder.complement')} class="inputDados"></input><br />
                <button  class="btn-address" >{t('pages.paymentData.next')}</button>
                
            </form>
                    
          );
         

        }
      }
      const handleSubmit = useCallback(( e ) =>{
        e.preventDefault();
        const address =[ stateInputRef.current?.value,
        cityInputRef.current?.value,
          zip_CodeInputRef.current?.value,
        numInputRef.current?.value];
             

             sessionStorage.setItem('address', JSON.stringify(address));
             if (paymentForm === "Cartão de Crédito") {
                setRouteChange( window.location.href="/checkout/pagamento-cartao");
    
            } else {
    
                setRouteChange( window.location.href="/checkout/obrigado-boleto");
              
            }
    
            
            
    },[]);
    var FormData = require('form-data');
    var data = new FormData();
    data.append('USER_TOKEN', USER_TOKEN);
    data.append('USER_EMAIL', USER_EMAIL);

    const axios = require('axios');
    useEffect(() => {
        api.get(`${BASE_URL}`, {
            headers: {
                'USER_EMAIL': USER_EMAIL,
                'USER_TOKEN': USER_TOKEN,
            }
        }).then(response => {

        }).catch(err => {
            if (err.status === 401) {
                history.push('/');
            }
        });

        var config = {
            method: 'get',
            url: ` ${BASE_URL}`,
            headers: {
                'Content-Type': 'application/json',
                'USER_TOKEN': USER_TOKEN,
                'USER_EMAIL': USER_EMAIL
            }
        };

        axios(config)
            .then(function (response) {

                console.log(response.data);



            })
            .catch(function (error) {
                console.log(error);
            });

    }, [USER_EMAIL, USER_TOKEN, history])


    return (

        <div  >
            
           <div class="address-container">
                <Header />

                <button class="btn-voltar" onClick={() => { history.go(-1) }}>  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14 arruma-arrow" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path></svg> </button> <div class="titulopagina"><TituloPagina titulo="Endereço" /></div>
            
                <div class="body-address">
                    
                    <div class="all-inputs-center">
                        <h3 class="text-config">{selectedPlan.name} - {selectedPlan.price}</h3>
                        <DataForm />
                        
                    </div>
                </div>
           

                <Footer />
            </div>
        </div>
    );
}
